"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
// @ts-ignore
var styled_components_1 = __importDefault(require("styled-components"));
var ScaleNumberSok_1 = __importDefault(require("../../ScaleNumber/ScaleNumberSok"));
var PriceSok_1 = __importDefault(require("../PriceSok"));
var Image_1 = __importDefault(require("../../Image"));
// note: height must be 100% - header
var LeftArea = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 50%;\n  height: 60%;\n  float: left;\n  padding-top: 50px;\n"], ["\n  width: 50%;\n  height: 60%;\n  float: left;\n  padding-top: 50px;\n"
    // note: height must be 100% - header
])));
// note: height must be 100% - header
var RightArea = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 50%;\n  height: 60%;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  float: right;\n"], ["\n  width: 50%;\n  height: 60%;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  float: right;\n"])));
var ItemMainContentSok = function (_a) {
    var _b = _a.product, productId = _b.productId, imagePath = _b.imagePath, scaleNumber = _b.scaleNumber, unit = _b.unit, scaleNumberLabel = _a.scaleNumberLabel, _c = _a.customSokStyles, sokItemPriceStyles = _c.sokItemPriceStyles, sokItemIntegersStyles = _c.sokItemIntegersStyles, sokItemDecimalsStyles = _c.sokItemDecimalsStyles, sokItemUnitStyles = _c.sokItemUnitStyles, sokItemImageStyles = _c.sokItemImageStyles, sokItemScaleNumberContainerStyles = _c.sokItemScaleNumberContainerStyles, sokItemScaleNumberStyles = _c.sokItemScaleNumberStyles, sokItemScaleNumberLabelStyles = _c.sokItemScaleNumberLabelStyles, priceIntegers = _a.priceIntegers, priceDecimals = _a.priceDecimals;
    var priceProps = {
        priceIntegers: priceIntegers,
        priceDecimals: priceDecimals,
        unit: unit,
        sokItemPriceStyles: sokItemPriceStyles,
        sokItemIntegersStyles: sokItemIntegersStyles,
        sokItemDecimalsStyles: sokItemDecimalsStyles,
        sokItemUnitStyles: sokItemUnitStyles
    };
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(LeftArea, null,
            react_1.default.createElement(PriceSok_1.default, __assign({}, priceProps))),
        react_1.default.createElement(RightArea, null,
            imagePath && (react_1.default.createElement(Image_1.default, { id: "".concat(productId, "-image"), styles: sokItemImageStyles, src: imagePath, alt: 'productImage' })),
            react_1.default.createElement(ScaleNumberSok_1.default, { label: scaleNumberLabel, scaleNumberContainerStyles: sokItemScaleNumberContainerStyles, scaleNumberStyles: sokItemScaleNumberStyles, scaleNumberLabelStyles: sokItemScaleNumberLabelStyles, scaleNumber: scaleNumber }))));
};
exports.default = ItemMainContentSok;
var templateObject_1, templateObject_2;
//# sourceMappingURL=ItemMainContentSok.js.map